module.exports = __webpack_public_path__ + "media/images/cart/insta-sample-f5523af243078cba57d3874a8e47cdce.jpg";